import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface SectionEditModuleState {
	uploading: boolean;
	moduleId: string;
	loading: boolean;
	userId: string;
}

@Injectable()
export class SectionEditModuleStore extends Store<SectionEditModuleState> {
	constructor() {
		super({ loading: true }, { name: `ui-section-edit-module-${guid()}` });
	}
}
